import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
  margin-top: 20px;
  position: relative;
  margin-bottom: 60px;

  &::before {
    content: "";
    top: 0px;
    left: -30px;
    display: block;
    position: absolute;
    width: 8px;
    height: 100%;
    background-color: #0D609D;
  }
`;
const UpperText = styled.div.withConfig({displayName:'-UpperText'})`
  color: #0D609D;
  font-weight: 500;
  font-size: 1rem;
`;
const Title = styled.div.withConfig({displayName:'-Title'})`  
  color: #0D609D;
  font-weight: 500;
  font-size: 3.4375rem;
  line-height: 50px;
`;
const LowerText = styled.div.withConfig({displayName:'-LowerText'})`  
  color: #657886;
  font-weight: 500;
  font-size: 1.1875rem;
  margin-top: 1rem;
`;


const MainTitle = ({title, upperText, lowerText}) => {
  return (
    <Wrapper>
		<UpperText>{upperText}</UpperText>
		<Title>{title}</Title>
		<LowerText>{lowerText}</LowerText>
    </Wrapper>
  )
}

export default MainTitle;
